import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {API} from "api";

export const useAnalyticsSummary = (days) => {
  return useQuery({
    queryKey: ["analytics-summary", days],
    queryFn: () => API.fetchAnalyticsSummary(days),
    refetchOnWindowFocus: false,
  });
};

export const useAnalyticsDaily = (days) => {
  return useQuery({
    queryKey: ["analytics-daily", days],
    queryFn: () => API.fetchAnalyticsDaily(days),
    refetchOnWindowFocus: false,
  });
};

export const useRendererHealth = () => {
  return useQuery({
    queryKey: ["renderer-health"],
    queryFn: () => API.fetchRendererHealth(),
    refetchInterval: 10000, // poll every 10 seconds
    refetchOnWindowFocus: false,
  });
};

export const useArtifactStats = () => {
  return useQuery({
    queryKey: ["artifact-stats"],
    queryFn: () => API.fetchArtifactStats(),
    refetchOnWindowFocus: false,
  });
};

/**
 * Kick off an Analytics Platform refresh. The server answers 202 and keeps
 * working for minutes, so the cache is invalidated rather than read back.
 */
export const useRefreshArtifactStats = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => API.refreshArtifactStats(),
    onSuccess: () => queryClient.invalidateQueries({queryKey: ["artifact-stats"]}),
  });
};
